import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions, unreportedCountSelector } from "components/advertising/logic/adActions";
import { currentUserIdSelector } from "components/login/logic/actions";
import { createDatesFromTimeFrame } from "core/date";
import envconfig from "../envconfig";

const useGetUnreportedCount = ({ timeFrameInDays = 5, initialDate = new Date() }) => {
    const userId = useSelector(currentUserIdSelector);
    const dispatch = useDispatch();
    const count = useSelector(unreportedCountSelector);
    useEffect(() => {
        if (userId) {
            const { futureDate: today, pastDate: fiveDaysAgo } = createDatesFromTimeFrame(timeFrameInDays, initialDate);

            const params = {
                userId: userId,
                dateFrom: fiveDaysAgo.toISOString().split("T")[0],
                dateTill: today.toISOString().split("T")[0],
            };

            dispatch(actions.SET_UNREPORTED_COUNT.send(params));
            const intervalId = setInterval(() => {
                dispatch(actions.SET_UNREPORTED_COUNT.send(params));
            }, envconfig.FR_UNREPORTED_COUNT_MS);

            return () => {
                clearInterval(intervalId);
            };
        }
    }, [dispatch, initialDate, timeFrameInDays, userId]);
    return {
        unreportedCount: count || 0,
    };
};

export default useGetUnreportedCount;
